
const useCart = {
    methods: {
        async addToCart(product) {
            console.log("addToCart", { product });
            try {
                await this.$store.dispatch("cart/addProduct", product);
            } catch (error) {
                this.$q.dialog({
                    title: "Error",
                    message: error.message
                })
            }
            // if (!this.$store.getters["authentication/authenticated"]) {
            //     return this.$router.push({
            //         name: "SignIn",
            //         query: {
            //             redirect: window.location.pathname,
            //         },
            //     });
            // }
            // const { error, noNotify } = await this.$store.dispatch(
            //     "cart/AddToCart",
            //     product
            // );

            // if (options.noNotify == false) {
            //     if(noNotify){
            //         // NOTE skip
            //     }else{
            //         this._notify(product, error);
            //     }
            // }

            // if (callback) {
            //     callback(error);
            // }
        },
        async decrementProduct(product) {
            console.log("decrementProduct", { product });
        },
    },
};

export default useCart;
